import React from 'react';
import { Animated, ScrollView, View, TouchableOpacity, Text, NativeSyntheticEvent, NativeScrollEvent } from 'react-native';
import WebIcon from './WebIcon';
import styles from './ItineraryEditor.styles';

const AnimatedScrollView = Animated.createAnimatedComponent(ScrollView);

interface TabStripProps {
  days: any[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  onTabLayout: (index: number, x: number, width: number) => void;
  isEditing?: boolean;
  onAddDay?: () => void;
  scrollRef?: React.RefObject<ScrollView>;
  onScroll?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
  onContainerLayout?: (width: number) => void;
  onContentSizeChange?: (contentWidth: number) => void;
}

const TabStrip: React.FC<TabStripProps> = ({
  days,
  selectedIndex,
  onSelect,
  onTabLayout,
  isEditing = false,
  onAddDay,
  scrollRef,
  onScroll,
  onContainerLayout,
  onContentSizeChange,
}) => {
  return (
    <AnimatedScrollView
      ref={scrollRef as any}
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.tabsStrip}
      onLayout={(e) => onContainerLayout && onContainerLayout(e.nativeEvent.layout.width)}
      onContentSizeChange={(width) => onContentSizeChange && onContentSizeChange(width)}
      onScroll={onScroll}
      scrollEventThrottle={16}
    >
      <View style={styles.tabsInnerStrip}>
        {days.map((d: any, idx: number) => {
          const isFirst = idx === 0;
          const isLast = idx === days.length - 1;
          const selected = selectedIndex === idx;
          // 使用 idx 作為 key（絕對唯一），不用 d.day（可能重複）
          const dayNumber = d.day || idx + 1;
          return (
            <TouchableOpacity key={`day-${idx}`} onPress={() => onSelect(idx)} onLayout={(e) => { const { x, width } = e.nativeEvent.layout; onTabLayout(idx, x, width); }} style={[styles.tabSegment, isFirst ? styles.tabSegmentFirst : null, isLast ? styles.tabSegmentLast : null, selected ? styles.tabSegmentActive : null]}>
              <Text style={[styles.tabSegmentTitle, selected ? styles.tabSegmentTitleActive : null]}>第{dayNumber}天</Text>
              <Text style={styles.tabSegmentSub}>{d.date ? d.date : ''}</Text>
            </TouchableOpacity>
          );
        })}
        {isEditing ? (
          <TouchableOpacity accessibilityRole="button" onPress={onAddDay} style={styles.tabAddDaySegment}><WebIcon name="add" size={20} color="#fff" /></TouchableOpacity>
        ) : null}
      </View>
    </AnimatedScrollView>
  );
};

export default TabStrip;
